/* eslint jsx-a11y/anchor-is-valid: 0 */

import React,{Component} from "react";

import {
  Card,
  CardHeader,
  CardBody,
  ListGroup,
  ListGroupItem,
  Button
} from "shards-react";

export default class SideBarAction extends Component{

    


    render(){
      return(
  
  <Card small className="mb-3">
    <CardHeader className="border-bottom">
      <h6 className="m-0">{"Actions"}</h6>
    </CardHeader>

    <CardBody className="p-0">
      <ListGroup flush>
        <ListGroupItem className="p-3">
          
          <span className="d-flex mb-2">
            <i className="material-icons mr-1">visibility</i>
            <strong className="mr-1">Visibility:</strong>{" "}
            <strong className={this.props.visibility==="Public"?"text-success":"text-danger"}>{this.props.visibility}</strong>{" "}
            <a className="ml-auto" href="#" onClick={this.props.edit}>
              Edit
            </a>
          </span>
        
        </ListGroupItem>
        <ListGroupItem className="d-flex px-3 border-0">
          <Button theme="accent" size="sm" onClick={this.props.onPublish}>
            <i className="material-icons">file_copy</i> Publish
          </Button>
          
        </ListGroupItem>
      </ListGroup>
    </CardBody>
  </Card>


        )
    }
}
